import {
  CERTS_LIST_ALL_TAB,
  CERTS_LIST_DONE_TAB,
  CERTS_LIST_TODO_TAB,
} from '../constant';

export const NO_RECORDS_MSGS = {
  [CERTS_LIST_TODO_TAB]: [
    {
      isAdmin: false,
      primaryText: 'CERTS_LIST_TODO_NO_RECORDS_MSG',
      secondaryText: 'CERTS_LIST_TODO_NO_RECORDS_DESCRIPTION',
      buttonText: 'CERTS_VIEW_ALL_CERTIFICATIONS',
    },
    {
      isAdmin: true,
      primaryText: 'CERTS_LIST_TODO_ADMIN_NO_RECORDS_MSG',
      secondaryText: 'CERTS_LIST_ADMIN_NO_RECORDS_DESCRIPTION',
      buttonText: 'CERTS_VIEW_ALL_CERTIFICATIONS',
    },
  ],
  [CERTS_LIST_DONE_TAB]: [
    {
      isAdmin: false,
      primaryText: 'CERTS_LIST_DONE_NO_RECORDS_MSG',
      secondaryText: 'CERTS_LIST_DONE_NO_RECORDS_DESCRIPTION',
      buttonText: 'CERTS_VIEW_ALL_CERTIFICATIONS',
    },
    {
      isAdmin: true,
      primaryText: 'CERTS_LIST_ADMIN_DONE_NO_RECORDS_MSG',
      secondaryText: 'CERTS_LIST_ADMIN_DONE_NO_RECORDS_DESCRIPTION',
      buttonText: 'CERTS_VIEW_ALL_CERTIFICATIONS',
    },
  ],
  [CERTS_LIST_ALL_TAB]: [
    {
      isAdmin: false,
      primaryText: 'CERTS_LIST_ALL_NO_RECORDS_MSG',
      secondaryText: 'CERTS_LIST_ALL_NO_RECORDS_DESCRIPTION',
    },
    {
      isAdmin: true,
      primaryText: 'CERTS_LIST_ADMIN_ALL_NO_RECORDS_MSG',
      secondaryText: 'CERTS_LIST_ADMIN_ALL_NO_RECORDS_DESCRIPTION',
      buttonText: 'CERTS_CONFIGURE_CAMPAIGN',
    },
  ],
};

export const NO_RECORDS_FILTERS_AND_SEARCH_QUERY_MSGS = {
  FILTER: {
    isAdmin: false,
    primaryText: 'CERTS_FILTERS_NO_RECORDS_MSG',
    secondaryText: 'CERTS_FILTERS_NO_RECORDS_DESCRIPTION',
    buttonText: 'CERTS_CLEAR_FILTERS',
  },
  SEARCH_QUERY: {
    isAdmin: false,
    primaryText: 'CERTS_SEARCH_NO_RECORDS_MSG',
    secondaryText: 'CERTS_SEACRH_NO_RECORDS_DESCRIPTION',
    buttonText: 'CERTS_CLEAR_SEARCH',
  },
};
